import Vue from 'vue';
import VueSanitize from 'vue-sanitize'

const defaultOptions = {
  allowedTags: [
    "h1", "h2", "h3", "h4","h5", "h6",
    "hgroup","dd","dl","hr",
    "li",  "ol", "p","ul", "b","br", "u", "i",
    "em", "small", "span", "strong", "div",
    "table", "tbody", "td", "tfoot", "th", "thead", "tr",
    "style", "center", "label", "font", "img","option", "select", 
  ],
  allowedAttributes: {
    'p': ["style"],
  },
};

Vue.use(VueSanitize, defaultOptions);
